<template>
    <div class="container rdv-w-layout-inner toggle-form-inner">
        <section class="confirm-page">
            <img class="confirm-page__icon confirm-page__icon--appointment-confirmed"
                 :src="imgSrc" loading="lazy" alt="">
            <h2 class="confirm-page__title" >
                Super <span>{{ formattedFirstName }}</span>, votre rendez-vous a bien été pris !
            </h2>
            <div class="confirm-page__buttons">
                <a :href="ics_url" class="btn-google-welcoming" download="event.ics" target="_blank">Rajouter à mon agenda Google</a>
            </div>
            <p class="confirm-page__info--appointment-confirmed">
                Pour votre RDV apportez un plan et/ou des photos de votre cuisine ou chargez-les dans votre Espace Perso pour gagner du temps.
                <img :src="imgSrcPictoConfirmed" loading="lazy" alt="" width="30px" height="30px">
            </p>
            <p class="confirm-page__info--appointment-confirmed confirm-page__info--bold">Connectez-vous en cliquant sur l’email d’activation qui vient de vous être envoyé !</p>
        </section>
    </div>
</template>
<script>
import collapseTransition from "@ivanv/vue-collapse-transition";

export default {
    name: "AppointmentConfirmed",
    components: {
        'collapse-transition': collapseTransition,
    },
    props: ['step','imgSrc', 'imgSrcPictoConfirmed', 'firstName', 'ics_url'],
    computed : {
        formattedFirstName() {
            if (!this.firstName) {
                return '';
            }
            const lower = this.firstName.trim().toLowerCase();
            return lower.charAt(0).toUpperCase() + lower.slice(1);
        }
    },
    watch: {
        step(newStep) {
            if (newStep === 'APPOINTMENT_CONFIRMED') {
                this.$nextTick(() => {
                    this.onVisible();
                });
            }
        }
    },
    methods :{
        onVisible(){
            document.querySelector('.bloc-left').style.display = 'none';
            this.addDataLayer();
        },
        addDataLayer(){
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                "event": "custom_event",
                "atEvent": "online_appointment.confirmation",
                "leadType": "appointment",
                "goalType": "online_appointment",
                "category": "online_appointment",
                "action" : "confirmation",
                "label" : ""
            });
            console.info("[GTM] Following data was added to dataLayer:")
            console.table(dataLayer)
        }
    }
}
</script>

<style>
</style>
